import ApiService from "@/common/api.service";
import {
  FETCH_VEHICLES,
  FETCH_VEHICLE,
  UPDATE_VEHICLE,
  CREATE_VEHICLE,
  RESET_VEHICLE,
  DELETE_VEHICLE
} from "./actions.type";
import {
  FETCH_VEHICLE_START,
  SET_VEHICLES,
  SET_VEHICLE
} from "./mutations.type";

const state = {
  vehicles: [],
  vehiclesCount: 1,
  vehicle: {},
  isLoading: false
};

const getters = {
  vehiclesCount: state => state.vehiclesCount,
  vehicles: state => state.vehicles,
  vehicle: state => state.vehicle,
  vehicleIsLoading: state => state.isLoading
};

const actions = {
  [FETCH_VEHICLES]({ commit }, [filteringCriteria, search]) {
    commit(FETCH_VEHICLE_START);
    return ApiService.filteredCollection(
      "vehicles",
      filteringCriteria,
      search
    ).then(({ data }) => {
      commit(SET_VEHICLES, data);
    });
  },
  [FETCH_VEHICLE](context, id) {
    return ApiService.get("vehicles", id).then(({ data }) => {
      context.commit(SET_VEHICLE, data);
    });
  },
  [UPDATE_VEHICLE](context, payload) {
    return ApiService.put(`vehicles/${payload.id}`, payload);
  },
  [CREATE_VEHICLE](context, payload) {
    return ApiService.post("vehicles", payload);
  },
  [RESET_VEHICLE](context) {
    context.commit(SET_VEHICLE, {});
  },
  [DELETE_VEHICLE](context, id) {
    return ApiService.delete("vehicles", id);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_VEHICLE_START](state) {
    state.isLoading = true;
  },
  [SET_VEHICLES](state, data) {
    state.vehicles = data.items || [];
    state.vehiclesCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_VEHICLE](state, data) {
    state.vehicle = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
